export interface PlantGrowthAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/discovery-lab/plant-growth-house';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): PlantGrowthAsset => ({ key, path: `${ROOT}/${path}`, width, height, alpha, required: true });

export const PLANT_GROWTH_ASSETS = {
  dormant: image(
    'plant-growth-dormant',
    'backgrounds/plant-growth-house-dormant.png',
    1280,
    720,
    false,
  ),
  restored: image(
    'plant-growth-restored',
    'backgrounds/plant-growth-house-restored.png',
    1280,
    720,
    false,
  ),
  card: image('plant-growth-record-card', 'interactives/growth-record-card.png', 640, 480, true),
} as const;

export const PLANT_GROWTH_ASSET_LIST = Object.values(PLANT_GROWTH_ASSETS);
// Browser/PWA runtime QA is required before opening this route to players.
export const PLANT_GROWTH_PRODUCTION_READY = true;

export function preloadPlantGrowthAssets(scene: Phaser.Scene): void {
  PLANT_GROWTH_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingPlantGrowthAssets(
  textures: Phaser.Textures.TextureManager,
): PlantGrowthAsset[] {
  return PLANT_GROWTH_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterPlantGrowthHouse(textures: Phaser.Textures.TextureManager): boolean {
  return PLANT_GROWTH_PRODUCTION_READY && getMissingPlantGrowthAssets(textures).length === 0;
}
